/**
 * UVP 主入口文件
 *
 * 职责：
 * 1. 初始化 React 根节点
 * 2. 全局配置 Ant Design ConfigProvider（主题、国际化等）
 * 3. 挂载 React Query Provider（TanStack Query）
 * 4. 渲染 App 组件
 *
 * @ref: uvp-theme.ts — 主题设计令牌
 */

import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getApiClientErrorStatus } from './api/apiClientError';

// 样式
import './styles/uvp-theme';
import App from './App';

// 主题配置
import { ThemeProvider } from './contexts/ThemeContext';
import { WorkspaceProvider } from './contexts/WorkspaceContext';

// ---- React Query 客户端（全局单例）----
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        const status = getApiClientErrorStatus(error);
        if (status === 401 || status === 403) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <WorkspaceProvider>
        <ThemeProvider>
          <AntdApp>
            <App />
          </AntdApp>
        </ThemeProvider>
      </WorkspaceProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
